import { Alert, Descriptions, Modal, Tag, Typography } from "antd";
import { formatInr } from "../utils/currency";
import { formatDate } from "../utils/date";

export type DeletePreviewField = {
  label: string;
  value?: unknown;
  type?: "date" | "money" | "tag";
};

export type ConfirmDeletePreviewFields = DeletePreviewField[];

export function confirmDeletePreview({
  title = "Confirm delete?",
  entityName = "record",
  fields,
  onConfirm,
  actionDescription,
  okText = "Yes, delete it"
}: {
  title?: string;
  entityName?: string;
  fields: DeletePreviewField[];
  onConfirm: () => Promise<void> | void;
  actionDescription?: string;
  okText?: string;
}) {
  Modal.confirm({
    title,
    width: 620,
    okText,
    okButtonProps: { danger: true },
    content: (
      <div className="delete-preview">
        <Alert
          type="warning"
          showIcon
          message={actionDescription ?? `This will delete the selected ${entityName}.`}
          description="Please verify the details below before continuing."
        />
        <Descriptions size="small" bordered column={1} className="delete-preview-details">
          {fields.filter((field) => field.value !== undefined && field.value !== null && field.value !== "").map((field) => (
            <Descriptions.Item key={field.label} label={field.label}>
              {renderPreviewValue(field)}
            </Descriptions.Item>
          ))}
        </Descriptions>
      </div>
    ),
    onOk: onConfirm
  });
}

function renderPreviewValue(field: DeletePreviewField) {
  if (field.type === "date") return formatDate(String(field.value));
  if (field.type === "money") return formatInr(Number(field.value ?? 0));
  if (field.type === "tag") return <Tag>{String(field.value)}</Tag>;
  return <Typography.Text>{String(field.value ?? "-")}</Typography.Text>;
}
